export enum PrivilegedRole {
  Superadmin = 'Superadmin',
  Flottenadmin = 'Flottenadmin',
  Partneradmin = 'Partneradmin',
}
